import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MessengerComponent} from './messenger.component';
import {MessengerService} from './messenger.service';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
    ],
    declarations: [
        MessengerComponent
    ],
    exports: [
        MessengerComponent
    ]
})
export class MessengerModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: MessengerModule,
            providers: [
                MessengerService
            ]
        };
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/messenger/messenger.module.ts